enum PersistorKey {
  TerminalUser = "terminalUser",
  User = "user",
  Ui_workbench = "ui_workbench",
}

export default PersistorKey
